import { render, staticRenderFns } from "./AdminMandateTerminationForm.vue?vue&type=template&id=b08111d6&scoped=true&"
import script from "./AdminMandateTerminationForm.vue?vue&type=script&lang=js&"
export * from "./AdminMandateTerminationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08111d6",
  null
  
)

export default component.exports